<ng-container *ngIf="!isLoading else loadingTemplate">

  <div class="container">
    <img src="assets/new-logo-2.png" alt="Bipperz logo" class="logo"/>
    <div class="info-container">
      <h2 class="title">{{ 'login_page.certificates' | translate }}</h2>

      <div class="file-upload-section">
        <div class="add-certification-button">
          <app-upload-form [materialType]="MaterialType.CV" (uploadedClicked)="displayModal()" (uploaded)="sendUploadedFile($event)"></app-upload-form>
        </div>
      </div>


      <div class="buttons">
        <div class="back-button">
          <app-button [isFullWidth]="true" [leftIcon]="'assets/icons/back.svg'"
                      [label]="'auth.back' | translate"
                      [size]="ButtonSize.LARGE"
                      [state]="ButtonState.REGULAR"
                      [type]="ButtonType.GHOST"
                      (click)="back()"></app-button>
        </div>

        <div class="skip-button">
          <app-button [isFullWidth]="true"
                      [label]="'shared.skip' | translate"
                      [size]="ButtonSize.LARGE"
                      [state]="ButtonState.REGULAR"
                      [type]="ButtonType.PRIMARY"
                      (click)="skip()"></app-button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loadingTemplate>
  <div class="popup-parsing-wrapper">
    <div class="popup-parsing-content">
      <img src="assets/loading-animation.png" alt="Loading animation" class="loading-icon"/>
      <p class="primary-text">We’re extracting key information from the CV to save you time.</p>
      <p class="secondary-text">This may take around 5 seconds.</p>
    </div>
  </div>
</ng-template>
